const panel = () => {
	document.getElementById('q_txt').addEventListener('keyup', panelTable, !1);
	panelTable();
};
const panelTable = () => {
	let tabla = document.getElementById('bodyTable');
	let _q = document.getElementById('q_txt').value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	let _tot = 0;
	//console.log(_q);
	while( tabla.firstChild ) {
		tabla.removeChild( tabla.firstChild );
	}
	for(let i in _data) {
		if(_q == '') {
			tabla.appendChild(addRowPanel(_data[i]));
			_tot++;
		} else {
			if(_data[i]._label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(_q) >= 0) {
				tabla.appendChild(addRowPanel(_data[i]));
				_tot++;
			}
		}
	}
	document.getElementById('stats_txt').innerHTML = `${_tot} Doctores`;
};
const addRowPanel = (_d) => {
	//console.log(_d);

	let _visi_date = (_d._date_visit == '0') ? '' : new Date(_d._date_visit * 1000);

	if(_visi_date != '') {
		_visi_date = _visi_date.getDate() + '/' + meses[_visi_date.getMonth()] + '/' + _visi_date.getFullYear();
	}

	return createCustomElement('tr',{},[
		createCustomElement('td',{'class':'text-muted small'},[_d._id]),
		createCustomElement('td',{},[_d._label]),
		createCustomElement('td',{},[_d._represent]),
		createCustomElement('td',{},[_d._phone]),
		createCustomElement('td',{'class':'small'},[_d._address_w]),
		createCustomElement('td',{'class':'small text-muted'},[_visi_date]),
		createCustomElement('td',{},[
			createCustomElement('a',{'href':'det.php?id='+_d._id},[
				createCustomElement('i',{'class':'fas fa-folder-plus'})
			])
		])
	]);
};